import type { ImportItem } from "../../../api/types";

export type ImportWarningCode =
  | "missing_date_range"
  | "partial_date_range"
  | "pending_diffs"
  | "needs_rerun";

export type ImportWarning = {
  code: ImportWarningCode;
  message: string;
};

export const getImportWarnings = (item: ImportItem): ImportWarning[] => {
  const warnings: ImportWarning[] = [];

  const hasFirst = !!item.firstTransactionDate;
  const hasLast = !!item.lastTransactionDate;
  if (!hasFirst && !hasLast) {
    warnings.push({
      code: "missing_date_range",
      message: "No transaction date range — import may have parsed 0 rows",
    });
  } else if (!hasFirst || !hasLast) {
    warnings.push({
      code: "partial_date_range",
      message: "Only one transaction date is set",
    });
  }

  const pending = item.pendingDiffCount ?? 0;
  if (pending > 0) {
    warnings.push({
      code: "pending_diffs",
      message: `${pending} pending update${pending === 1 ? "" : "s"} waiting to apply`,
    });
  }

  if (item.needsRerun) {
    warnings.push({
      code: "needs_rerun",
      message:
        "Importer changed since this import — re-run to process the file again",
    });
  }

  return warnings;
};

export const hasImportWarnings = (item: ImportItem): boolean =>
  getImportWarnings(item).length > 0;
